<template>
<div >
	<Loader :show="loading"></Loader>
	<b-modal id="modalMissing" hide-footer hide-header no-close-on-backdrop no-close-on-esc @close="close" size="lg">
		
		<div class="fullscreen">
			<div class="head">
				<div class="container">
					<div class="btn icon icon-close invert" @click="close"></div>
					<h1>{{title}}</h1>
				</div>
			</div>
			<div class="content">
				<div class="container">
					
					<b-form-group label="Descripción" class="mt-4">
						<textarea-autosize
						placeholder="Ingrese la descripción del faltante"
						v-model="form.description"
						:min-height="70"
						:max-height="350"
						class="form-control"
						/>
					</b-form-group>
					<div class="invalid-feedback d-block" v-if="validation.hasError('form.description')">Ingrese una descripción</div>

				</div>
			</div>
			<div class="footer">
				<div class="container">
					<div class="btn btn-block btn-primary" @click="save()">
						<span v-if="form.key">Editar faltante</span>
						<span v-else>Crear faltante</span>
					</div>
				</div>
			</div>
		</div>

	</b-modal>	
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Loader from '@/components/Loader'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'MissingModal',
	components:{
		Loader,
	},
	data () {
		return {
			title: 'Crear faltante',
			show: false,
			loading:false,
			saving: false,
			form:{
				key: null,
				description:null,
			},
		}
	},
	computed: {
		...mapState(['control']),
	},
	validators: {
		'form.description': function (value) {
			return Validator.value(value).required();
		},
	},
	methods: {
		...mapMutations(['saveControl']),
		
		checkValidation() {
			return this.$validate()
			.then(function (success) {
				if (success) {
					return true
				}
				return false
			});
		},
		open () {
			this.showModal()
		},
		update (missing) {
			this.title = 'Editar faltante'
			this.form = missing
			this.showModal()
		},
		showModal() {
			this.show = true
			this.$bvModal.show('modalMissing')
		},
		close () {
			this.$bvModal.hide('modalMissing')
			this.form = {
				key: null,
				description:null,
			}
			this.$emit('updated')
		},
		async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
				if(!this.form.key){
					this.form.key = this.control.missings.length+1
					this.control.missings.push(this.form)
				}
				this.saveControl(this.control)
				this.saving = false
				this.close()
			}
		}
	}
}


</script>

<style lang="scss" scoped>
	.types{
		width: 100%;
		display: flex;
		justify-content: center;

		.btn-type{
			text-align: center;
			margin:0px 6px;
			
			.btn{
				background-size: contain;
				border: #fff;
			}
			.label{
				font-size: .8rem;
				text-transform: uppercase;
			}

			&.selected .btn{
				border: solid 2px #2c8ece;
			}
		}
	}
</style>